<template>
<iframe ref="iframe" :src="sendSmsUrl" width="100%" height="700" frameborder="0" scrolling="auto" />
</template>

<script>
export default {
    data() {
        return {
            sendSmsUrl: 'http://duanxin.yunkawulian.com:999/999.php'
        }
    },
    methods: {
        loaded() {
            console.log("ccc:" + this.$refs.iframe.contentWindow.document.body.clientHeight);
        }
    },
    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// sendsms_hebei.vue?1dbcbdca